import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=00123996&scoped=true"
import script from "./NoteCard.vue?vue&type=script&lang=js"
export * from "./NoteCard.vue?vue&type=script&lang=js"
import style0 from "./NoteCard.vue?vue&type=style&index=0&id=00123996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00123996",
  null
  
)

export default component.exports